enum Contact {
  SET_CONTACT_INITIALIZE = 'SET_CONTACT_INITIALIZE',
  SET_CONTACT_INFO = 'SET_CONTACT_INFO'
}

export default Contact;
